// ====================================================================
// ziven-theme-aura v0.2.6 forum/index.js (r.16)
// ====================================================================
//
// 移动端 Drawer + 桌面端 Sidebar (隐藏) 改版主入口
// - modifyDrawer: 移动端 (< 992px) drawer 模式, 注入 user-block + 5 stats + nav
// - modifySidebar: 桌面端 (>= 992px) sidebar 模式 (辉哥 15:10 拍板隐藏, 代码保留)
// - modifyNavItems: 美化 vendor + 扩展注入的 nav item
// - modifyHeaderSecondary: 桌面端 HeaderSecondary 注入 "发布主题" 蓝底方按钮 (v0.2.3 新)
// - modifyDiscussionHero: v0.2.6 移动端 d/:id 改设计 (辉哥 2026-09-16 10:41 拍板 v6, r.16)
//   - Hero 标题从 hero 移除 → 移到 Post-main 里 Post-header 下面 (.PostHeroTitle 卡片)
//   - 关注按钮从 hero 完全移除 → 在 Post-main 第一个 Post 的 .Post-header 行右侧新建
//   - 桌面端不动
//
// Flarum 2.0 vendor namespace:
//   - flarum/forum/components/HeaderPrimary (扩展点, vendor 默认空 ItemList)
//   - flarum/forum/components/HeaderSecondary (vendor 默认有 search + locale + logIn;
//     移动端抽屉里是整块 .App-drawer .Header-secondary 被 v0.2.8 hotfix 藏掉
//     (less/forum.less:590-594) ⇒ 抽屉内的 search 按钮真机点不到 (0×0);
//     桌面端 .App-header 内的 header-secondary 保留)
//   - flarum/forum/components/DiscussionHero (extend oncreate/onupdate 移动 title)
//   - flarum/forum/components/CommentPost (extend headerItems 注入 follow-user button)
//   - flarum/common/components/Avatar (Flarum 原生 Avatar 组件)
//   - flarum/common/components/Badge / GroupBadge (原生 .Badge 组件, 复用 ziven-core 颜色)
//
// v0.2.3 关键改动 (辉哥 15:10 拍板):
//   - 桌面端 sidebar 容器 (>= 992px) CSS display: none 隐藏 (代码保留)
//   - 桌面端 HeaderSecondary 注入 "发布主题" 蓝底方按钮 (跟 ziven.ski 1:1)
//   - 桌面端 header-secondary 整体图标样式跟 ziven.ski 真实 1:1
//   - App-content 顶部 "发布讨论" 按钮保留 (辉哥说不删)
//   - 移动端 < 992px 不动 (drawer 模式保持现状)
//
// v0.2.14.a 关键改动 (辉哥 2026-09-04 15:00 反馈, 拍板 v0.2.14.a):
//   - 删 mobileComposer.js (整个文件, 含 v0.2.5f 仿小黑盒 composer dead code + v0.2.5f.c force show 段)
//   - 根因 (辉哥 15:00 iPhone 真机亲测): 进入 /d/:id 帖子页, 移动端 (< 992px) 自动 force
//     vendor composer show (mobileComposer.js L417-489), vendor Composer 进入 normal+active+visible
//     状态, 350px 高的全屏式 composer 自动弹出, 挡在帖子内容上. 禁用 ziven-theme-aura 后
//     问题消失, 走 vendor 默认 (composer hidden, 用户点 "回复" 才弹).
//   - 修法: 删 mobileComposer.js 整个文件 + index.js 删 import + 调用, 走 vendor 默认.
//     跟辉哥"禁用扩展后正常"行为一致.
//   - 影响范围: 只移动端 (< 992px) DiscussionPage composer, 桌面端不动 (本来就走 vendor 默认).
//   - 副作用: less/forum.less 里 .ziven-composer-* 段 (v0.2.5f 配套) 变成 dead CSS, 暂保留
//     (v0.2.14.a 返工 minimal change, CSS 清理留 v0.2.15+ 单独任务).
//
// v0.2.6 关键改动 (辉哥 2026-09-16 10:41 拍板 v6 设计图, r.16):
//   - 移动端 DiscussionPage 改设计 (辉哥 Query 9/16 10:23):
//     1) 关注按钮从 hero 顶部完全移除 → 移到 Post-main 里 Post-header 行右侧
//     2) 用户名+头像 区域在 Post-header 行左侧 (flex 布局, flex:1 推按钮到右侧)
//     3) 标题从 hero 移除 → 移到 Post-main 里 Post-header 下面 (amber 左边框卡片)
//     4) 桌面端 (@media (min-width: 992px)) 完全不动
//   - 关注按钮用的是 flarum/follow-users 扩展 (vendor DOM), HTML 不能改,
//     只 CSS 隐藏 hero 那个 + 在 Post-main 渲染一个
//   - 实现:
//     - CSS: less/forum.less v0.2.6 段 (19.x), @media (max-width: 991.98px) 限定移动端
//     - JS: modifyDiscussionHero.js, extend DiscussionHero oncreate/onupdate 把 title
//       移到 Post-main; extend CommentPost headerItems 在第一个 Post 注入 follow-user 按钮
//   - 回滚锚 H1 tag (v0.2.5f.i = a510b5b). 走不通立刻 git checkout H1.
// ====================================================================

import app from 'flarum/common/app';
import { extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import modifyDrawer from './modifyDrawer';
import modifySidebar from './modifySidebar';
import modifyNavItems from './modifyNavItems';
import modifyHeaderSecondary from './modifyHeaderSecondary';
import modifyHeaderLogo from './modifyHeaderLogo';
import modifyDiscussionHero from './modifyDiscussionHero';
import { applyStoredScheme } from './appearanceSwitcher';
app.initializers.add('ziiven-theme-aura', () => {
  // 1. 移动端 drawer 注入 (user-block + 5 stats + nav)
  modifyDrawer();

  // 2. 桌面端 sidebar 注入 (辉哥 15:10 拍板: 桌面端隐藏, 代码保留, CSS display: none)
  modifySidebar();

  // 3. 美化 nav item (vendor + 扩展注入的, 不主动加)
  modifyNavItems();

  // 4. 桌面端 HeaderSecondary 注入 "发布主题" 蓝底方按钮 (v0.2.3 新)
  modifyHeaderSecondary();

  // 5. v0.2.12 移动端未登录 bjxy logo 替换 (辉哥 2026-09-03 10:21 + 21:48 反馈, 从 bjxy 扩展迁移)
  // 任何 ziven 项目只要 bjxy_brand_logo_url 有值, 未登录侧栏都显示品牌 logo (64x64 圆角 居中)
  modifyHeaderLogo();

  // 6. v0.2.6 移动端 d/:id 改设计 (辉哥 2026-09-16 10:41 拍板 v6, r.16)
  // Hero 标题移到 Post-main, 关注按钮移到 Post-header 行右侧
  modifyDiscussionHero();

  // 7. HeaderPrimary 扩展点 (vendor 兼容, 给其他扩展留接口)
  extend(HeaderPrimary.prototype, 'items', function (items) {
    // v0.2.0 移动端 + 桌面端共用 vendor HeaderPrimary.items() ItemList
    // nav item 由 modifyNavItems.js 主动加 (5 主体 + 1 separator + 3 账号)
  });

  // 8. v0.2.20 游客态配色守卫: 恢复未登录态被记住的浅色/深色选择 (sessionStorage 被禁时降级 localStorage)
  applyStoredScheme();
});